import styles from './index.module.scss'

export function SimpleLoader() {
  return (
    <div className={styles.ldsellipsis}>
      <div />
      <div />
      <div />
      <div />
    </div>
  )
}
